import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { ProfileBillingAddress, TempBillingAddress } from '../../utils/constants';

interface BillingSaveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (option: typeof ProfileBillingAddress | typeof TempBillingAddress) => void;
}

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  position: 'relative',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: '#17457a',
}));

const BillingSaveModal = ({ isOpen, onClose, onSave }: BillingSaveModalProps) => {
  const [saveOption, setSaveOption] = useState<
    typeof ProfileBillingAddress | typeof TempBillingAddress
  >(ProfileBillingAddress);

  if (!isOpen) return null;

  return (
    <div className="billingconfirmationdialog">
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        BackdropProps={{ invisible: true }}
        PaperProps={{
          sx: {
            minHeight: '25vh',
            minWidth: '50vw',
            borderRadius: '5px',
          },
        }}
      >
        <StyledDialogTitle id="customized-dialog-title">
          <Typography variant="h6">Confirmation</Typography>
          <CloseButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>
        <DialogContent>
          <div className="billingaddsaveoptions">
            <div>
              <input
                type="radio"
                name="billingSaveOption"
                value="ProfileBillingAddress"
                checked={saveOption === ProfileBillingAddress}
                onChange={() => setSaveOption(ProfileBillingAddress)}
              />
              <label htmlFor="updateProfile">Update my profile with this address</label>
            </div>
            <div>
              <input
                type="radio"
                name="billingSaveOption"
                value="TempBillingAddress"
                checked={saveOption === TempBillingAddress}
                onChange={() => setSaveOption(TempBillingAddress)}
              />
              <label htmlFor="temporaryAddress">
                Use as a temporary billing address for this order only
              </label>
            </div>
          </div>
        </DialogContent>
        <div className="billingaddsaveaction">
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              autoFocus
              onClick={() => {
                onSave(saveOption);
                onClose();
              }}
            >
              Save
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

export default BillingSaveModal;
